module.exports = __webpack_public_path__ + "static/media/checkmarkOff_118.fb43773a.png";